import { DESKTOP_DOWNLOADS } from '@/lib/desktop-releases'

export const MIN_DESKTOP_AUTO_UPDATE_VERSION = '0.1.2'

export interface DesktopUpdatePromptInfo {
  currentVersion: string
  downloadUrl: string
}

function compareVersions(a: string, b: string): number {
  const aParts = a.split('.').map(part => Number(part))
  const bParts = b.split('.').map(part => Number(part))
  const length = Math.max(aParts.length, bParts.length)

  for (let i = 0; i < length; i += 1) {
    const aPart = Number.isFinite(aParts[i]) ? aParts[i] : 0
    const bPart = Number.isFinite(bParts[i]) ? bParts[i] : 0
    if (aPart !== bPart) return aPart - bPart
  }

  return 0
}

function getDownloadUrl(userAgent: string): string {
  if (/\bWindows\b/i.test(userAgent)) return DESKTOP_DOWNLOADS.windows
  if (/\bMacintosh\b|\bMac OS X\b|\bMacintosh;/i.test(userAgent)) return DESKTOP_DOWNLOADS.macArm
  return '/download'
}

export function getDesktopUpdatePromptInfo(userAgent: string): DesktopUpdatePromptInfo | null {
  // desktop-v0.1.0 and desktop-v0.1.1 used MartiniDesktop/<version> but
  // pointed electron-updater at private GitHub releases. desktop-v0.1.2+
  // switched to the fixed R2 feed and later builds temporarily sent a bare
  // MartiniDesktop token, so unversioned shells should not be prompted.
  const match = /\bMartiniDesktop\/(\d+\.\d+\.\d+)\b/.exec(userAgent)
  if (!match) return null

  const currentVersion = match[1]
  if (compareVersions(currentVersion, MIN_DESKTOP_AUTO_UPDATE_VERSION) >= 0) return null

  return {
    currentVersion,
    downloadUrl: getDownloadUrl(userAgent),
  }
}
